import angular from 'angular';

module.exports = angular.module('common.models.responser', [])
.factory('Responser', function($http) {
  return {
    appendTransform: function(fn) {
      var defaults = $http.defaults.transformResponse;
      defaults = angular.isArray(defaults) ? defaults : [defaults];

      return defaults.concat(fn);
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/responser.js
 **/